export default {
  /**
   * Fetch all enteries from skill table
   */
  async fetchAllSkills ({ commit }) {
    try {
      const response = await this._vm.$network_utils.getAllSkills()
      commit('setSkillList', response)
    } catch (e) {
      console.error(e)
    }
  }
}
